module.exports = __webpack_public_path__ + "img/btFull.1cdad0ed.png";